class ScLiveViewersRoot extends HTMLElement {
  static readTemplateText(root, selector) {
    const el = root.querySelector(selector);
    if (!el) return '';
    if (el instanceof HTMLTemplateElement) {
      return el.content.textContent.trim();
    }
    return el.textContent.trim();
  }

  connectedCallback() {
    // Prevent multiple initializations
    if (this.initialized) return;
    this.initialized = true;
    
    this.textEl = this.querySelector('[data-sc-live-viewers-text]');
    this.templates = {
      1: ScLiveViewersRoot.readTemplateText(this, '[data-sc-live-template="1"]'),
      2: ScLiveViewersRoot.readTemplateText(this, '[data-sc-live-template="2"]'),
      3: ScLiveViewersRoot.readTemplateText(this, '[data-sc-live-template="3"]'),
    };
    this.countMin = Number.parseInt(this.dataset.countMin, 10);
    this.countMax = Number.parseInt(this.dataset.countMax, 10);
    if (Number.isNaN(this.countMin)) this.countMin = 3;
    if (Number.isNaN(this.countMax)) this.countMax = 8;
    if (this.countMax < this.countMin) {
      const t = this.countMin;
      this.countMin = this.countMax;
      this.countMax = t;
    }
    this.tier2Ms = Number.parseInt(this.dataset.tier2Ms, 10) || 30000;
    let tier3 = Number.parseInt(this.dataset.tier3Ms, 10) || 90000;
    this.tier3Ms = Math.max(tier3, this.tier2Ms + 15000);
    this.startedAt = performance.now();
    this.currentTier = 1;
    this.applyTier(1);
    
    if (this.timer) window.clearInterval(this.timer);
    this.timer = window.setInterval(() => this.checkTier(), 500);
  }

  disconnectedCallback() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
    this.initialized = false;
  }

  randomCount() {
    const min = this.countMin;
    const max = this.countMax;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  formatTemplate(tier, count) {
    const raw = this.templates[tier] || this.templates[1];
    return raw.replace(/\{count\}/gi, String(count));
  }

  applyTier(tier) {
    if (!this.textEl) return;
    const count = this.randomCount();
    this.textEl.textContent = this.formatTemplate(tier, count);
  }

  checkTier() {
    const elapsed = performance.now() - this.startedAt;
    let tier = 1;
    if (elapsed >= this.tier3Ms) tier = 3;
    else if (elapsed >= this.tier2Ms) tier = 2;

    if (tier !== this.currentTier) {
      this.currentTier = tier;
      this.applyTier(tier);
    }
    if (tier === 3 && this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('sc-live-viewers-root')) {
  customElements.define('sc-live-viewers-root', ScLiveViewersRoot);
}